<swipesum-header [appName]="'CPO Portal'"></swipesum-header>

<div style="display: flex; justify-content: center; align-items: center; height: 100vh;">
    <mat-progress-spinner mode="indeterminate" [diameter]="200"></mat-progress-spinner>    
</div>
